module.exports = __webpack_public_path__ + "static/img/ServiceWorkOrder.bd3ad4b6.png";